module.exports = __webpack_public_path__ + "static/media/fly0223.70c3c3dd.webp";